var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgAttachMedia = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 16C12.4183 16 16 12.4183 16 8C16 3.58172 12.4183 0 8 0C3.58172 0 0 3.58172 0 8C0 12.4183 3.58172 16 8 16Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7333 11.6666V4.33327C12.7333 3.73327 12.2666 3.2666 11.6666 3.2666H4.33327C3.73327 3.2666 3.2666 3.73327 3.2666 4.33327V11.6666C3.2666 12.2666 3.73327 12.7333 4.33327 12.7333H11.6666C12.2666 12.7333 12.7333 12.2666 12.7333 11.6666ZM6.39994 9.0666L7.53327 10.3999L9.13327 8.33327C9.2666 8.19993 9.4666 8.19993 9.53327 8.33327L11.3999 10.7999C11.5333 10.9333 11.3999 11.1999 11.1999 11.1999H4.8666C4.6666 11.1999 4.4666 10.9333 4.6666 10.7999L5.99993 9.13327C6.0666 8.8666 6.2666 8.8666 6.39994 9.0666Z",
    fill: "white"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgAttachMedia, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/attach_media.e32082ad.svg";
export { ForwardRef as ReactComponent };